import { formatDeviceTimestamp } from "../../../api/mocks/accountDevices.mock.js";

export function createAccountHistoryEntry({ action, accountId, accountName, createdAt }) {
  return {
    id: `ah-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`,
    action,
    accountId: accountId ?? null,
    accountName: accountName ?? "—",
    createdAt: createdAt ?? new Date().toISOString(),
  };
}

export function createSimHistoryEntry({ action, simId, simIccid, simType, previousSimId, previousSimIccid, previousSimType, createdAt }) {
  return {
    id: `sh-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`,
    action,
    simId: simId ?? null,
    simIccid: simIccid ?? "—",
    simType: simType ?? "—",
    previousSimId: previousSimId ?? null,
    previousSimIccid: previousSimIccid ?? null,
    previousSimType: previousSimType ?? null,
    createdAt: createdAt ?? new Date().toISOString(),
  };
}

export function formatAccountHistoryAction(entry) {
  if (entry.action === "assigned") return `Assigned to ${entry.accountName}`;
  if (entry.action === "deassigned") return `Deassigned from ${entry.accountName}`;
  return entry.action;
}

export function formatSimHistoryAction(entry) {
  if (entry.action === "bound") return `SIM bound · ${entry.simIccid}`;
  if (entry.action === "changed") {
    const from = entry.previousSimIccid ?? "—";
    return `SIM changed · ${from} → ${entry.simIccid}`;
  }
  if (entry.action === "unbound") return `SIM unbound · ${entry.simIccid}`;
  return entry.action;
}

export function formatBindingTimestamp(iso) {
  return formatDeviceTimestamp(iso);
}

export function accountHistoryTone(action) {
  return action === "assigned" ? "positive" : "neutral";
}

export function simHistoryTone(action) {
  if (action === "bound") return "positive";
  if (action === "changed") return "info";
  return "neutral";
}
